<template>
  <popup
    :opened.sync="popupOpened"
    :use-footer="true"
    @confirm="confirm"
    @cancel="() => {$emit('update:opened', false)}"
  >
    <template #content>
      <!-- <vue-pdf-app style="height: 100vh;" :pdf="pdfUrl" :config="pdfconfig" :page-number="1"></vue-pdf-app> -->
    </template>
  </popup>
</template>

<script>
// import VuePdfApp from "vue-pdf-app";
// import "vue-pdf-app/dist/icons/main.css";
export default {
  name: "PDFViewer",
  // components: { VuePdfApp },
  props: {
    pdfUrl: {
      type: String,
      required: true,
    },
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pdfconfig: {
        sidebar: false,
        secondaryToolbar: false,
        toolbar: {
          toolbarViewerLeft: { findbar: false },
        },
      },
    };
  },
  computed: {
    popupOpened: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
